import React from "react";

import { useState } from "react";
import StoreContext from "./code-context";
let project;
if (JSON.parse(localStorage.getItem("projectArr") == null)) {
  project = [];
} else project = JSON.parse(localStorage.getItem("projectArr"));

export default function AppProvider(props) {
  const [isDark, setIsDark] = useState(true);
  const [isFile, setIsFile] = useState(false);
  const [projectPrefix, setPorjectprefix] = useState("");

  const addHandler = (data) => {
    project = [data, ...project];
    localStorage.setItem("projectArr", JSON.stringify(project));
  };
  const storeContextHelper = {
    appData: project,
    addData: addHandler,
    Dark: isDark,
    IsDark: setIsDark,
    File: isFile,
    IsFile: setIsFile,
    Prefix: projectPrefix,
    setPrefix: setPorjectprefix,
  };
  return (
    <StoreContext.Provider value={storeContextHelper}>
      {props.children}
    </StoreContext.Provider>
  );
}
